{
  "labels": {
    "paste": "ஒட்டு",
    "pasteAsPlaintext": "அலங்காரமின்றி ஒட்டு",
    "pasteCharts": "விளக்கப்படங்களை ஒட்டு",
    "selectAll": "எல்லாம் தேர்ந்தெடு",
    "multiSelect": "உறுப்பைத் தெரிவில் சேர்",
    "moveCanvas": "கித்தானை நகர்த்து",
    "cut": "வெட்டு",
    "copy": "நகலெடு",
    "copyAsPng": "நகலகத்திற்கு PNG ஆக நகலெடு",
    "copyAsSvg": "நகலகத்திற்கு SVG ஆக நகலெடு",
    "copyText": "நகலகத்திற்கு உரையாக நகலெடு",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "முன்நோக்கி கொண்டுவா",
    "sendToBack": "பின்னே அனுப்பு",
    "bringToFront": "முன்னே கொண்டுவா",
    "sendBackward": "பின்நோக்கி அனுப்பு",
    "delete": "அழி",
    "copyStyles": "ஒயில்களை நகலெடு",
    "pasteStyles": "ஒயில்களை ஒட்டு",
    "stroke": "கீறல்",
    "background": "பின்புலம்",
    "fill": "நிரப்பல்",
    "strokeWidth": "கீறல் அகலம்",
    "strokeStyle": "கீறல் ஒயில்",
    "strokeStyle_solid": "திடமான",
    "strokeStyle_dashed": "கோடிட்ட",
    "strokeStyle_dotted": "புள்ளியிட்ட",
    "sloppiness": "அசட்டுத்தனம்",
    "opacity": "ஒளிபுகாவியல்பு",
    "textAlign": "உரைச் சீரமைப்பு",
    "edges": "விளிம்புகள்",
    "sharp": "கூர்மை",
    "round": "வட்டம்",
    "arrowheads": "அம்புத்தலைகள்",
    "arrowhead_none": "ஏதுமில்லை",
    "arrowhead_arrow": "அம்பு",
    "arrowhead_bar": "பட்டை",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "முக்கோணம்",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "எழுத்துரு அளவு",
    "fontFamily": "எழுத்துரு குடும்பம்",
    "addWatermark": "\"எக்ஸ்கேலிட்ரா கொண்டு ஆனது\"-ஐச் சேர்",
    "handDrawn": "கையால்-வரைந்த",
    "normal": "இயல்பு",
    "code": "குறியீடு",
    "small": "சிறிய",
    "medium": "நடுத்தரமான",
    "large": "பெரிய",
    "veryLarge": "மிகப் பெரிய",
    "solid": "திடமான",
    "hachure": "மலைக்குறிக்கோடு",
    "zigzag": "கோணல்மாணல்",
    "crossHatch": "குறுக்குகதவு",
    "thin": "மெல்லிய",
    "bold": "பட்டை",
    "left": "இடது",
    "center": "மையம்",
    "right": "வலது",
    "extraBold": "கூடுதல் பட்டை",
    "architect": "கட்டடக்கலைஞர்",
    "artist": "கலைஞர்",
    "cartoonist": "கேலிச்சித்திர ஓவியர்",
    "fileTitle": "கோப்புப் பெயர்",
    "colorPicker": "நிறத் தேர்வி",
    "canvasColors": "கித்தானில் பயன்படுத்தப்பட்டது",
    "canvasBackground": "கித்தான் பின்னணி",
    "drawingCanvas": "கித்தான் வரைகிறது",
    "layers": "அடுக்குகள்",
    "actions": "செயல்கள்",
    "language": "மொழி",
    "liveCollaboration": "நேரடி கூட்டுப்பணி...",
    "duplicateSelection": "நகலாக்கு",
    "untitled": "தலைப்பற்றது",
    "name": "பெயர்",
    "yourName": "உங்கள் பெயர்",
    "madeWithExcalidraw": "எக்ஸ்கேலிட்ரா கொண்டு ஆனது",
    "group": "தேர்ந்ததை ஒன்றிணை",
    "ungroup": "தேர்ந்ததைப் பிரி",
    "collaborators": "கூட்டுப்பணியினர்",
    "showGrid": "கட்டதைக் காட்டு",
    "addToLibrary": "நூலகத்தில் சேர்",
    "removeFromLibrary": "நூலகத்திலிருந்து நீக்கு",
    "libraryLoadingMessage": "நூலகத்தை ஏற்றுகிறது…",
    "libraries": "நூலகங்களை உலாவு",
    "loadingScene": "காட்சியை ஏற்றுகிறது…",
    "align": "சீரமை",
    "alignTop": "மேலே சீரமை",
    "alignBottom": "கீழே சீரமை",
    "alignLeft": "இடதில் சீரமை",
    "alignRight": "வலதில் சீரமை",
    "centerVertically": "செங்குத்தாக மையப்படுத்து",
    "centerHorizontally": "கிடைமட்டமாக மையப்படுத்து",
    "distributeHorizontally": "கிடைமட்டமாக விநியோகி",
    "distributeVertically": "செங்குத்தாக விநியோகி",
    "flipHorizontal": "கிடைமட்டமாக புரட்டு",
    "flipVertical": "செங்குத்தாக புரட்டு",
    "viewMode": "பார்வை பயன்முறை",
    "share": "பகிர்",
    "showStroke": "கீறல் நிற எடுப்பானைக் காட்டு",
    "showBackground": "பின்னணி நிற எடுப்பானைக் காட்டு",
    "toggleTheme": "தோற்றத்தை நிலைமாற்று",
    "personalLib": "தனக்குரிய நூலகம்",
    "excalidrawLib": "எக்ஸ்கேலிட்ரா நூலகம்",
    "decreaseFontSize": "எழுத்துரு அளவைக் குறை",
    "increaseFontSize": "எழுத்துரு அளவை அதிகரி",
    "unbindText": "உரையைப் பிணைவவிழ்",
    "bindText": "உரையைக் கொள்கலனுக்குப் பிணை",
    "createContainerFromText": "உரையைக் கொள்கலனுள் சுருட்டு",
    "link": {
      "edit": "தொடுப்பைத் திருத்து",
      "editEmbed": "",
      "create": "தொடுப்பைப் படை",
      "createEmbed": "",
      "label": "தொடுப்பு",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "தொடுப்பைத் திருத்து",
      "exit": "வரி திருத்தியிலிருந்து வெளியேறு"
    },
    "elementLock": {
      "lock": "பூட்டு",
      "unlock": "பூட்டவிழ்",
      "lockAll": "எல்லாம் பூட்டு",
      "unlockAll": "எல்லாம் பூட்டவிழ்"
    },
    "statusPublished": "வெளியிடப்பட்டது",
    "sidebarLock": "பக்கப்பட்டையைத் திறந்தே வை",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "கித்தானிலிருந்து நிறம் தேர்ந்தெடு",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "இதுவரை உருப்படிகள் சேரக்கப்படவில்லை...",
    "hint_emptyLibrary": "கித்தானிலுள்ள உருப்படியை இங்குச் சேர்க்க தேர்ந்தெடு, அல்லது கீழுள்ள பொது களஞ்சியத்திலிருந்து நூலகத்தை நிறுவு.",
    "hint_emptyPrivateLibrary": "கித்தானிலுள்ள உருப்படியை இங்குச் சேர்க்க தேர்ந்தெடு."
  },
  "buttons": {
    "clearReset": "கித்தானை அகரமாக்கு",
    "exportJSON": "கோப்புக்கு ஏற்றுமதிசெய்",
    "exportImage": "படத்தை ஏற்றுமதிசெய்...",
    "export": "இதில் சேமி...",
    "copyToClipboard": "நகலகத்திற்கு நகலெடு",
    "save": "தற்போதைய கோப்புக்குச் சேமி",
    "saveAs": "இப்படி சேமி",
    "load": "திற",
    "getShareableLink": "பகிரக்கூடிய தொடுப்பைப் பெறு",
    "close": "மூடு",
    "selectLanguage": "மொழியைத் தேர்ந்தெடு",
    "scrollBackToContent": "உருட்டி உள்ளடக்கத்துக்குத் திரும்பு",
    "zoomIn": "பெரிதாக்கு",
    "zoomOut": "சிறிதாக்கு",
    "resetZoom": "உருவளவை அகரமாக்கு",
    "menu": "சிறுபட்டி",
    "done": "முடிந்தது",
    "edit": "திருத்து",
    "undo": "செயல்தவிர்",
    "redo": "மீண்டும்செய்",
    "resetLibrary": "நூலகத்தை அகரமாக்கு",
    "createNewRoom": "புதிய அறையை உருவாக்கு",
    "fullScreen": "முழுத் திரை",
    "darkMode": "கருமை பயன்முறை",
    "lightMode": "வெளிர்ந்த பயன்முறை",
    "zenMode": "ஜென் பயன்முறை",
    "objectsSnapMode": "",
    "exitZenMode": "ஜென் பயன்முறையை விலகு",
    "cancel": "ரத்துசெய்",
    "clear": "துடை",
    "remove": "நீக்கு",
    "embed": "",
    "publishLibrary": "பிரசுரி",
    "submit": "சமர்ப்பி",
    "confirm": "உறுதிசெய்",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "இது முழு கித்தானையும் துடைக்கும். நீங்கள் உறுதியா?",
    "couldNotCreateShareableLink": "பகிரக்கூடிய தொடுப்பை உருவாக்க முடியவில்லை.",
    "couldNotCreateShareableLinkTooBig": "பகிரக்கூடிய தொடுப்பை உருவாக்க முடியவில்லை: காட்சி மிகப்பெரிதாக உள்ளது",
    "couldNotLoadInvalidFile": "செல்லாத கோப்பை ஏற்ற முடியவில்லை",
    "importBackendFailed": "தேகத்திலிருந்து இறக்குமதி தோல்வி.",
    "cannotExportEmptyCanvas": "காலியான கித்தானை ஏற்றுமதிசெய்ய முடியாது.",
    "couldNotCopyToClipboard": "நகலகத்திற்கு நகலெடுக்க முடியவில்லை.",
    "decryptFailed": "தரவை மறைநீக்க முடியவில்லை.",
    "uploadedSecurly": "பதிவேற்றம் இருமுனை மறையாகத்தால் பாதுகாக்கப்பட்டுள்ளது, எனவே எக்ஸ்கேலிட்ரா சேவையகமும் மூன்றாம் தரப்பினரும் உள்ளடக்கத்தை வாசிக்கமுடியாது.",
    "loadSceneOverridePrompt": "வெளிப்புறச்சித்திரமேற்றல் இருக்கிற உள்ளடக்கத்தை இடங்கொள்ளும். தொடர விருப்பமா?",
    "collabStopOverridePrompt": "அமர்வை நிறுத்துதல் முன்னர் அகமாக தேக்கிய உம் சித்திரத்தை மேலெழுதும். நீங்கள் உறுதியா?\n\n(உம் அக சித்திரத்தை வைக்கவேண்டுமெனில், சும்மா உலாவி தாவலை மூடுக அதற்குபதிலாக.)",
    "errorAddingToLibrary": "உருப்படியை நூலகத்தில் சேர்க்க இயலா",
    "errorRemovingFromLibrary": "உருப்படியை நூலகத்திலிருந்து நீக்க இயலா",
    "confirmAddLibrary": "இதனால் {{numShapes}} வடிவம்(கள்) உம் நூலகத்தில் சேரும். நீங்கள் உறுதியா?",
    "imageDoesNotContainScene": "இப்படத்தில் காட்சி தரவு ஏதும் இருப்பதுபோல் தெரியவில்லை. ஏற்றுமதியின்போது காட்சி உட்பதிதலை இயக்கினீரா?",
    "cannotRestoreFromImage": "இப்படக்கோப்பிலிருந்து காட்சி மீட்டெடுக்கப்பட முடியாது",
    "invalidSceneUrl": "வழங்கப்பட்ட உரலியிலிருந்து காட்சியை இறக்கவியலா. இது தவறான வடிவத்தில் உள்ளது, அ செல்லத்தக்க எக்ஸ்கேலிட்ரா JSON தரவைக் கொண்டில்லை.",
    "resetLibrary": "இது உங்கள் நுலகத்தைத் துடைக்கும். நீங்கள் உறுதியா?",
    "removeItemsFromsLibrary": "{{count}} உருப்படி(கள்)-ஐ உம் நூலகத்திலிருந்து அழிக்கவா?",
    "invalidEncryptionKey": "மறையாக்க விசை 22 வரியுருக்கள் கொண்டிருக்கவேண்டும். நேரடி கூட்டுப்பணி முடக்கப்பட்டது.",
    "collabOfflineWarning": "இணைய இணைப்பு இல்லை.\nஉமது மாற்றங்கள் சேமிக்கப்படா!"
  },
  "errors": {
    "unsupportedFileType": "ஆதரிக்கப்படா கோப்பு வகை.",
    "imageInsertError": "படத்தைப் புகுத்தவியலா. பிறகு மீண்டும் முயலவும்...",
    "fileTooBig": "கோப்பு மிகப்பெரிது. அனுமதிக்கப்பட்ட அதிகபட்ச அளவு {{maxSize}}.",
    "svgImageInsertError": "எஸ்விஜி படத்தைப் புகுத்தவியலா. எஸ்விஜியின் மார்க்அப் செல்லாததாக தெரிகிறது.",
    "failedToFetchImage": "",
    "invalidSVGString": "செல்லாத SVG.",
    "cannotResolveCollabServer": "கூட்டுப்பணிச் சேவையகத்துடன் இணைக்க முடியவில்லை. பக்கத்தை மீளேற்றி மீண்டும் முயலவும்.",
    "importLibraryError": "நூலகத்தை ஏற்ற முடியவில்லை",
    "collabSaveFailed": "பின்முனை தரவுத்தளத்தில் சேமிக்க முடியவில்லை. சிக்கல்கள் நீடித்தால், உமது வேலைகளை இழக்காமலிருப்பதை உறுதிசெய்ய உமது கோப்பை உள்ளகத்தில் சேமிக்க வேண்டும்.",
    "collabSaveFailed_sizeExceeded": "பின்முனை தரவுத்தளத்தில் சேமிக்க முடியவில்லை, கித்தான் மிகப்பெரிதாகத் தெரிகிறது. உமது வேலைகளை இழக்காமலிருப்பதை உறுதிசெய்ய உமது கோப்பை உள்ளகத்தில் சேமிக்க வேண்டும்.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "தெரிவு",
    "image": "படத்தைப் புகுத்து",
    "rectangle": "செவ்வகம்",
    "diamond": "வைரம்",
    "ellipse": "நீள்வட்டம்",
    "arrow": "அம்பு",
    "line": "வரி",
    "freedraw": "வரை",
    "text": "உரை",
    "library": "நூலகம்",
    "lock": "தேர்ந்த கருவியை வரைந்த பின்பும் வைத்திரு",
    "penMode": "பேனா - தடுப்பு தொடுதல்",
    "link": "தேர்தெடுத்த வடிவத்திற்குத் தொடுப்பைச் சேர்/ புதுப்பி",
    "eraser": "அழிப்பி",
    "frame": "சட்டகம் கருவி",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "கை (பார்வை நகர்கும் கருவி)",
    "extraTools": "மற்ற கருவிகள்",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "கித்தான் செயல்கள்",
    "selectedShapeActions": "தேர்ந்த வடிவம் செயல்கள்",
    "shapes": "வடிவங்கள்"
  },
  "hints": {
    "canvasPanning": "",
    "linearElement": "பல புள்ளிகளைத் துவக்க சொடுக்கு, ஒற்றை வரிக்கு பிடித்திழு",
    "freeDraw": "சொடுக்கி பிடித்திழு, முடித்ததும் விடுவி",
    "text": "துணுக்குதவி: தெரிவு கருவி கொண்டு எங்காவது இரு-சொடுக்கி உரையைச் சேர்க்கலாம்",
    "embeddable": "",
    "text_selected": "உரையைத் திருத்த இரு-சொடுக்கு அ ENTERஐ அழுத்து",
    "text_editing": "திருத்துவதை முடிக்க Escape அ CtrlOrCmd+ENTERஐ அழுத்து",
    "linearElementMulti": "கடைசி புள்ளியில் சொடுக்கு அ முடிக்க Escape அ Enter அழுத்து",
    "lockAngle": "SHIFTஐ அழுத்திப்பிடித்து கோணத்தை வற்புறுத்தலாம்",
    "resize": "மறுஅளவிடுகையில் SHIFTஐ அழுத்திப்பிடித்து விகிதசமத்தை வற்புறுத்தலாம்,\nமையத்திலிருந்து மறுஅளவிட ALTஐ அழுத்திப்பிடி",
    "resizeImage": "SHIFTஐ நீண்டழுத்தி கட்டற்று அளவுமாற்றலாம்,\nமையத்திலிருந்து அளவுமாற்ற ALTஐ நீண்டழுத்துக",
    "rotate": "சுழற்றுகையில் SHIFTஐ அழுத்திப்பிடித்து கோணங்களை வற்புறுத்தலாம்",
    "lineEditor_info": "",
    "lineEditor_pointSelected": "புள்ளி(கள்)ஐ நீக்க Deleteஐ அழுத்து,\nநகலாக்க CtrlOrCmd+D, அ நகர்த்த பிடித்திழு",
    "lineEditor_nothingSelected": "திருத்த புள்ளியைத் தேர்ந்தெடு (பலவற்றை தேர SHIFTஐ அழுத்திப்பிடி),\nஅ புதிய புள்ளிகளைச் சேர்க்க Altஐ அழுத்திப்பிடித்துச் சொடுக்கு",
    "placeImage": "படத்தை வைக்கச் சொடுக்கு, அ கைமுறையாக அளவு அமைக்க சொடுக்கி பிடித்திழு",
    "publishLibrary": "உம் சொந்த நூலகத்தைப் பிரசுரி",
    "bindTextToElement": "உரையைச் சேர்க்க enterஐ அழுத்து",
    "deepBoxSelect": "ஆழ்ந்துத் தேரவும் பிடித்திழுத்தலைத் தவிர்க்கவும் CtrlOrCmdஐ அழுத்திப்பிடி",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "முன்னோட்டம் காட்ட இயலவில்லை",
    "canvasTooBig": "கித்தான் மிகப்பெரிதாக இருக்கலாம்.",
    "canvasTooBigTip": "துணுக்குதவி: தூரத்திலுள்ள உறுப்புகளைப் நெருக்கமாக நகர்த்தப்பார்."
  },
  "errorSplash": {
    "headingMain": "பிழையைச் சந்தித்தீரா. முயலவும் <button>பக்கத்தை மீண்டுமேற்றுகிறது.</button>",
    "clearCanvasMessage": "மீண்டுமேற்றல் வேலைசெய்யவிட்டால், முயற்சி <button>கித்தானைத் துடைக்கிறது.</button>",
    "clearCanvasCaveat": " இது வேலையை இழக்கக்கூடும் ",
    "trackedToSentry": "இனங்காணியில் பிழை {{eventId}} எங்கள் இயங்குதளத்தில் தடமறியப்பட்டது.",
    "openIssueMessage": "பிழையில் உம் காட்சி தகவலை உள்ளடக்காமலிருக்க நாங்கள் மிக எச்சரிக்கையாக இருந்தோம். உம் காட்சி தனிப்பட்டதில்லையெனில், பின்தொடர்வதற்கு பரிசீலிக்கவும் எங்கள் <button>பிழை தடமி.</button> கீழுள்ள தகவலை நகலெடுத்து ஒட்டி GitHub சிக்கலுள் உள்ளடக்கவும்.",
    "sceneContent": "காட்சி உள்ளடக்கம்:"
  },
  "roomDialog": {
    "desc_intro": "உம்முடன் கூட்டுப்பணிசெய்ய மக்களை தற்போதைய காட்சிக்கு அழைப்பிடலாம்.",
    "desc_privacy": "வருந்தாதீர், அமர்வு இருமுனை மறையகத்தைப் பயன்படுத்துகிறது, ஆக நீங்கள் வரைவது எதுவும் தனிப்பட்டதாக இருக்கும். எங்கள் சேவையகத்தால் கூட நீங்கள் என்ன செய்ததைப் பார்க்கவியலாது.",
    "button_startSession": "அமர்வைத் துவக்கு",
    "button_stopSession": "அமர்வை நிறுத்து",
    "desc_inProgressIntro": "நேரடி-கூட்டுப்பணி அமர்வு தற்போது செயலிலுள்ளது.",
    "desc_shareLink": "கூட்டுப்பணிபுரிய விரும்பும் எவருனும் இத்தொடுப்பைப் பகிர்க:",
    "desc_exitSession": "அமர்வை நிறுத்தல் உம்மை அறையிலிருந்து துண்டிக்கும், ஆனால் காட்சியுடன் தொடர்ந்து பணிபுரிய உம்மாலியலும், அகமாக. இது பிற மக்களைப் பாதிக்காதென்பதைக் குறி, மற்றும் அவர்களாலவர்களுடைய பதிப்பில் இன்னும் கூட்டுப்பணிபுரியவியலும்.",
    "shareTitle": "எக்ஸ்கேலிட்ராவில் நேரடி கூட்டுப்பணி அமர்வில் சேர்"
  },
  "errorDialog": {
    "title": "பிழை"
  },
  "exportDialog": {
    "disk_title": "வட்டில் சேமி",
    "disk_details": "காட்சித் தரவை நீங்கள் பின்னர் இறக்குமதி செய்யக்கூடிய ஒரு கோப்பிற்கு ஏற்றுமதிசெய்க.",
    "disk_button": "கோப்பில் சேமி",
    "link_title": "பகிரக்கூடிய தொடுப்பு",
    "link_details": "வாசிக்க-மட்டும் தொடுப்பாக ஏற்றுமதிசெய்.",
    "link_button": "தொடுப்புக்கு ஏற்றுமதிசெய்",
    "excalidrawplus_description": "காட்சியை உன் எக்ஸ்கேலிட்ரா பணியிடத்தில் சேமி.",
    "excalidrawplus_button": "ஏற்றுமதி",
    "excalidrawplus_exportError": "இத்தருணத்தில் எக்ஸ்கேலிட்ரா+ க்கு ஏற்றுமதிசெய்ய முடியவில்லை..."
  },
  "helpDialog": {
    "blog": "எமது வலைப்பூவை வாசி",
    "click": "சொடுக்கு",
    "deepSelect": "ஆழ்ந்துத் தேர்",
    "deepBoxSelect": "பெட்டியினுள் ஆழ்ந்துத் தேர், மற்றும் பிடித்திழுத்தலைத் தவிர்",
    "curvedArrow": "வளைந்த அம்பு",
    "curvedLine": "வளைந்த வரி",
    "documentation": "ஆவணமாக்கல்",
    "doubleClick": "இரு-சொடுக்கு",
    "drag": "பிடித்திழு",
    "editor": "திருத்தி",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "சிக்கலைக் கண்டீரா? சமர்ப்பி",
    "howto": "எங்கள் கையேடுகளைப் பின்பற்றுக",
    "or": "அ",
    "preventBinding": "அம்பு பிணைதலைத் தவிர்",
    "tools": "கருவிகள்",
    "shortcuts": "விசைப்பலகை குறுக்குவழிகள்",
    "textFinish": "திருத்துதலை முடி (உரை திருத்தி)",
    "textNewLine": "புதிய வரியைச் சேர் (உரை திருத்தி)",
    "title": "உதவி",
    "view": "பார்",
    "zoomToFit": "அனைத்துறுப்புகளும் பொருந்தும்படி விரிவாக்கு",
    "zoomToSelection": "தெரிவுக்கு விரிவாக்கு",
    "toggleElementLock": "தேர்ந்தெடுப்பைப் பூட்டு/பூட்டவிழ்",
    "movePageUpDown": "மேலே/கீழே நகர்த்தவும்",
    "movePageLeftRight": "இடது/வலது பக்கம் நகர்த்தவும்"
  },
  "clearCanvasDialog": {
    "title": "கித்தானைத் துடை"
  },
  "publishDialog": {
    "title": "நூலகத்தைப் பிரசுரி",
    "itemName": "உருப்படியின் பெயர்",
    "authorName": "ஆசிரியர் பெயர்",
    "githubUsername": "GitHub பயனர்பெயர்",
    "twitterUsername": "டுவிட்டர் பயனர்பெயர்",
    "libraryName": "நூலக பெயர்",
    "libraryDesc": "நூலக விவரிப்பு",
    "website": "வலைத்தளம்",
    "placeholder": {
      "authorName": "உம் பெயர் அ பயனர்பெயர்",
      "libraryName": "உம் நூலகத்தின் பெயர்",
      "libraryDesc": "உம் நூலகத்தின் விவரிப்பு இதன் பயன்பாட்டை மக்கள் புரிந்துகொள்ளவுதவ",
      "githubHandle": "GitHub கைப்பிடி (விரும்பினால்), ஆதலால் நீங்கள் நூலகத்தை மதிப்பாய்விற்காக சமர்ப்பித்தவுடன் திருத்தமுடியும்",
      "twitterHandle": "டுவிட்டர் பயனர்பெயர் (விரும்பினால்), ஆதலால் டுவிட்டரில் முன்னிறுத்தும்போது யாமெவரைப் புகழ்வதென்றறிவோம்",
      "website": "உமக்குரிய வலைத்தளத்திற்கு அ வேறெங்கிற்குமான தொடுப்பு (விரும்பினால்)"
    },
    "errors": {
      "required": "தேவைப்டுகிறது",
      "website": "செல்லத்தக்க உரலியை உள்ளிடு"
    },
    "noteDescription": "உம் நூலகத்தைச் சமர்ப்பி உள்ளடக்குவதற்கு <link>பொது நூலக களஞ்சியத்தில்</link>பிற மக்களவர்களின் சித்திரங்களில் பயன்படுத்த.",
    "noteGuidelines": "நூலகம் முதலில் கைமுறையாக ஒப்புக்கொள்ளப்படவேண்டும். வாசிக்கவும் <link>வழிகாட்டுதல்களைச்</link> சமர்ப்பிக்கும் முன்பு. கோரப்பட்டால் தொடர்புகொள்ள மற்றும் மாற்றங்கள் செய்ய உமக்கொரு GitHub கணக்கு தேவை, ஆனால் அது கண்டிப்பாக தேவையல்ல.",
    "noteLicense": "சமர்ப்பிப்பதனால், நூலகம் இதனடியில் பிரசரிக்கப்பட ஏற்கிறீர்கள் <link>MIT உரிமம், </link>சுருக்கமாக எவருமிதைப் வரையறையின்றி பயன்படுத்தலாமென குறிக்கிறது.",
    "noteItems": "வடிக்கட்டக்கூடியதாகவிருக்க ஒவ்வொரு நூலகவுருப்படிக்கும் சொந்த பெயர் இருக்கவேண்டும். பின்வரும் நூலகவுருப்படிகள் உள்ளடக்கப்படும்:",
    "atleastOneLibItem": "ஆரம்பிக்க ஒரு நூலக உருப்படியையாவது தேர்ந்தெடுக்கவும்",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "நூலகம் சமர்ப்பிக்கப்பட்டது",
    "content": "நன்றி {{authorName}}. உமது நூலகம் மதிப்பாய்விற்காக சமர்ப்பிக்கப்பட்டது. நிலையை நீங்கள் தடமறியலாம்<link>இங்கே</link>"
  },
  "confirmDialog": {
    "resetLibrary": "நூலகத்தை அகரமாக்கு",
    "removeItemsFromLib": "நூலகத்திலிருந்து தேர்ந்தெடுத்த உருப்படிகளை நீக்கு"
  },
  "imageExportDialog": {
    "header": "படத்தை ஏற்றுமதிதல",
    "label": {
      "withBackground": "பின்னணி",
      "onlySelected": "தேர்ந்ததை மட்டும்",
      "darkMode": "இருள் பயன்முறை",
      "embedScene": "காட்சியை உட்பொதி",
      "scale": "அளவுகோல்",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "PNGக்கு ஏற்றுமதிசெய்",
      "exportToSvg": "SVGக்கு ஏற்றுமதிசெய்",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "உம் சித்திரங்கள் இருமுனை மறையாக்கம் செய்யப்பட்டவையாதலால் எக்ஸ்கேலிட்ராவின் சேவையகங்கள் அவற்றை ஒருபோதும் பார்க்கா.",
    "link": "எக்ஸ்கேலிட்ராவில் இருமுனை மறையாக்கம் மீதான வலைப்பூ இடுகை"
  },
  "stats": {
    "angle": "கோணம்",
    "element": "உறுப்பு",
    "elements": "உறுப்புகள்",
    "height": "உயரம்",
    "scene": "காட்சி",
    "selected": "தேர்ந்தவை",
    "storage": "சேமிப்பகம்",
    "title": "மேதாவிகளுக்கான புள்ளிவிவரங்கள்",
    "total": "மொத்தம்",
    "version": "பதிப்பு",
    "versionCopy": "நகலெடுக்க சொடுக்கு",
    "versionNotAvailable": "பதிப்பு கிடைக்கவில்லை",
    "width": "அகலம்"
  },
  "toast": {
    "addedToLibrary": "நூலகத்தில் சேர்க்கப்பட்டது",
    "copyStyles": "ஒயில்கள் நகலெடுக்கப்பட்டன.",
    "copyToClipboard": "நகலகத்திற்கு நகலெடுக்கப்பட்டது.",
    "copyToClipboardAsPng": "{{exportSelection}}-ஐ நகலகத்திற்கு PNG ஆக நகலெடுத்தது\n({{exportColorScheme}})",
    "fileSaved": "கோப்பு சேமிக்கப்பட்டது.",
    "fileSavedToFilename": "{filename}-க்கு சேமிக்கப்பட்டது",
    "canvas": "கித்தான்",
    "selection": "தெரிவு",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "ஒளிபுகுத்தன்மை",
    "black": "கருப்பு",
    "white": "வெள்ளை",
    "red": "சிவப்பு",
    "pink": "இளஞ்சிவப்பு",
    "grape": "திராட்சை",
    "violet": "ஊதா",
    "gray": "சாம்பல்",
    "blue": "நீலம்",
    "cyan": "மயில்நிறம்",
    "teal": "டீல்",
    "green": "பச்சை",
    "yellow": "மஞ்சள்",
    "orange": "ஆரஞ்சு",
    "bronze": "வெண்கலம்"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "எளிமையாக வரைபடங்கள் உருவாக்க!",
      "toolbarHint": "கருவியைத் தேர்ந்தெடு & வரை!",
      "helpHint": "குறுக்குவழிகள் & உதவி"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
